import styled from '@emotion/styled';
import {
    fontSizes,
    fontWeights,
    lineHeights,
    colors,
    boxSizes,
    gutterSizes,
} from '../base/theme';
import TextArea from '../form/text-area';

const shouldForwardProp = (p: string) => !["error"].includes(p);

export const MessageTextArea = styled(TextArea, {
    shouldForwardProp,
})<{ error: boolean }>`
    display: block;
    font-size: ${fontSizes.medium};
    line-height: ${lineHeights.base};
    font-weight: ${fontWeights.normal};
    letter-spacing: 0.15px;
    color: ${colors.bark};
    white-space: pre-line;
    border-color: ${({ error }) => (error ? colors.red : undefined)};
    border-radius: ${boxSizes.borderRadius4};
    padding: ${gutterSizes.medium};
    &:focus, &:focus-visible {
        border-color: ${colors.bark80};
        outline: none;
    }
`;

export const Errors = styled.ul`
    grid-area: error-messages;

    li {
        color: ${colors.red};
    }
`;

export const MessageTextAreaCount = styled.div`
    font-size: ${fontSizes.smaller};
    line-height: 18px;
    color: ${colors.newDarkGrey};
    text-align: right;
    margin-top: ${gutterSizes.small};
`;
